<template>
    <div>
        <div class="mb-10 w-full">
            <div class="w-max relative mx-auto">
                <Icon name="heroicons-outline:search" class="flex-none w-4 h-4 absolute bottom-[0.75rem] left-2" />
                <input type="text" placeholder="Search through articles..."
                    class="block mx-auto rounded-lg indent-4 w-64 p-2 px-4 border border-gray-300" v-model="search" />
            </div>
        </div>
        <div class="md:sticky top-16 z-[15] py-3 bg-white flex justify-center">
            <ArticleFilterTags :checked="tag" @change="filterArticles" />
        </div>
        <div>
            <div class="grid-cols-[repeat(auto-fill,minmax(19rem,1fr))] grid gap-10 justify-around mt-5"
                v-if="visibleCount">
                <template v-for="article in filteredArticles" :key="article?.id">
                    <ArticleTile :article="article" />
                </template>
                <div class="col-span-full">
                    <hr />
                    <span class="mt-4 block">
                        Showing <span class="font-bold">{{ visibleCount }}</span> of <span class="font-bold">{{
                            allArticles?.length }}</span> results
                    </span>
                </div>
            </div>
            <div v-else-if="!search">
                <div class="w-max p-4 mx-auto text-lg">
                    We don't have any articles with the tag <span class="text-secondary-500 font-bold">{{ tag }}</span>
                    yet,
                    subscribe to our newsletter so you don't miss anything
                </div>
            </div>
            <div v-else>
                <div class="w-max p-4 mx-auto text-lg">
                    We found nothing with a title containing <span class="text-secondary-500 font-bold">{{ search
                        }}</span>,
                    subscribe to our newsletter so you don't miss anything
                </div>
            </div>
        </div>
        <!-- <template v-if="tag === 'tutorial'">
            <ArticlesCardGridGrouped :groupedArticles="groupedArticles" />
        </template> -->
    </div>
</template>
<script setup lang="ts">
const allArticles = await queryContent('/').where({ _path: /^\/(news|blog|developers\/tutorials|developers\/showcases)\//, 'article': { '$exists': true }, 'author': { '$exists': true }, _draft: false }).sort({ 'article.date': -1 }).without(['body']).find()
const route = useRoute()
const tag = route.query.tag ? ref(`${route.query.tag}`) : ref("")
const search = ref("")
const filteredArticles = computed(() => {
    return allArticles.filter(article => {
        const matchesSearch = search.value
            ? article.title.match(new RegExp(search.value, 'ig')) ||
            article?.keywords?.some(k => k.toLowerCase().includes(search.value.toLowerCase()))
            : true;

        return matchesSearch && matchesTagFilter(article?.article?.tags)
    })
})
const visibleCount = computed(() => filteredArticles.value.length)
console.log("tag:", tag.value)

const filterArticles = (ev) => {
    tag.value = ev?.target?.value && ev?.target?.value != "all" ? ev.target.value : ""
    console.log("New tag:", tag.value)
    if (tag.value) {
        return navigateTo({
            replace: true,
            query: {
                tag: tag.value
            }
        })
    }

}

const matchesTagFilter = (tags) => {

    if (tags.includes("community") && tag.value !== "community") {
        return false
    }
    if (tag.value === "all" || !tag.value) {
        return true
    }
    return tags.includes(tag.value)
}

</script>

<style lang="css">
.fade-enter-active {
    animation: fade-in 0.4s;
}

.fade-leave-active {
    animation: fade-in 0.4s reverse;
}

@keyframes fade-in {
    from {
        opacity: 0;
        transform: scale(0);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}
</style>

<style lang="scss" scoped>
.news__container {
    grid-template-columns: repeat(auto-fill, minmax(19rem, 1fr))
}

.news__container-cards {
    grid-template-columns: repeat(auto-fill, minmax(19rem, 1fr))
}
</style>
